import { render, staticRenderFns } from "./orderItemValueChartWidget.vue?vue&type=template&id=1cc8af78&"
import script from "./orderItemValueChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderItemValueChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports